import { PortalInviteStatusDto, type PortalSourcingEventDetailDto } from "../../../../autogen/bff-api";
import { isInvitedCompetition } from "../isInvitedCompetition";

export const readsWithoutAnInvitation = (event: PortalSourcingEventDetailDto): boolean =>
  isInvitedCompetition(event.contextType) && event.myInviteStatus === PortalInviteStatusDto.NotInvited;
